var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MFA_AUTH_ACTION } from '@actions/actions/authentication/mfa-auth-action';
import IpfsHash from 'ipfs-only-hash';
import { LitAbility, LitActionResource, LitPKPResource } from '@lit-protocol/auth-helpers';
import { ethers } from 'ethers';
import { ENV_LIT_NETWORK, LIT_RPC_URL } from '@shared/utils/config/environment';
import { getLitContractClient } from './litContract';
import { getAuthId } from './getAuthId';
export var getMFAActionId = function (pkp, sessionSig) { return __awaiter(void 0, void 0, void 0, function () {
    var litContractClient, litActionHash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getLitContractClient(pkp.publicKey, sessionSig)];
            case 1:
                litContractClient = _a.sent();
                return [4 /*yield*/, IpfsHash.of(MFA_AUTH_ACTION)];
            case 2:
                litActionHash = _a.sent();
                return [2 /*return*/, litContractClient.utils.getBytesFromMultihash(litActionHash)];
        }
    });
}); };
export var checkMFA = function (pkp, sessionSig, currentAuthMethod) { return __awaiter(void 0, void 0, void 0, function () {
    var _mfaInfo, startTime, result, data, litContractClient, authId, _a, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                console.log('WUJI Start checkMFA');
                _mfaInfo = {};
                startTime = new Date().toISOString();
                return [4 /*yield*/, fetch('/api/auth/mfa-info', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 1:
                result = _b.sent();
                return [4 /*yield*/, result.json()];
            case 2:
                data = _b.sent();
                console.log('WUJI checkMFA 0', data, new Date().getTime() - new Date(startTime).getTime());
                startTime = new Date().toISOString();
                if (data === null || data === void 0 ? void 0 : data.mfaInfo) {
                    _mfaInfo.presentMFAInfo = {
                        authMethodType: data.mfaInfo.auth_method_type,
                        authId: data.mfaInfo.auth_id,
                        providerValue: data.mfaInfo.provider_value,
                    };
                }
                return [4 /*yield*/, getLitContractClient(pkp.publicKey, sessionSig)];
            case 3:
                litContractClient = _b.sent();
                console.log('WUJI checkMFA 1', new Date().getTime() - new Date(startTime).getTime());
                startTime = new Date().toISOString();
                return [4 /*yield*/, getAuthId(currentAuthMethod, pkp, sessionSig)];
            case 4:
                authId = _b.sent();
                console.log('WUJI checkMFA 2 ', new Date().getTime() - new Date(startTime).getTime());
                startTime = new Date().toISOString();
                _a = _mfaInfo;
                return [4 /*yield*/, litContractClient.pkpPermissionsContract.read.getPermittedAuthMethodScopes(pkp.tokenId, currentAuthMethod.authMethodType, authId, 3)];
            case 5:
                _a.scopes =
                    _b.sent();
                console.log('WUJI checkMFA 3', new Date().getTime() - new Date(startTime).getTime());
                console.log('WUJI End checkMFA', _mfaInfo);
                return [2 /*return*/, _mfaInfo];
            case 6:
                e_1 = _b.sent();
                console.log('WUJI Error in checkMFA', e_1);
                return [2 /*return*/, null];
            case 7: return [2 /*return*/];
        }
    });
}); };
export var getMFASessionSig = function (pkp, currentAuthMethod, MFAAuthMethod, litNodeClient, sessionLength, litSession, setMFAProgress) { return __awaiter(void 0, void 0, void 0, function () {
    var mfaauthresponse, _a, _b, e_2, _c, _d, _e, litActionSessionSigs, _f, _g;
    var _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    return __generator(this, function (_4) {
        switch (_4.label) {
            case 0:
                _4.trys.push([0, 4, , 7]);
                _b = (_a = litNodeClient).executeJs;
                _h = {
                    code: MFA_AUTH_ACTION,
                    sessionSigs: litSession
                };
                _j = {
                    tokenId: (_u = ethers.BigNumber.from(pkp.tokenId)) === null || _u === void 0 ? void 0 : _u.toHexString(),
                    publicKey: pkp.publicKey
                };
                _k = {};
                return [4 /*yield*/, getAuthId(currentAuthMethod, pkp, litSession)];
            case 1:
                _j.auth1 = (_k.authId = _4.sent(),
                    _k.authMethodType = (_v = currentAuthMethod.authMethodType) === null || _v === void 0 ? void 0 : _v.toString(),
                    _k);
                _l = {};
                return [4 /*yield*/, getAuthId(MFAAuthMethod, pkp, litSession)];
            case 2: return [4 /*yield*/, _b.apply(_a, [(_h.jsParams = (_j.auth2 = (_l.authId = _4.sent(),
                        _l.authMethodType = (_w = MFAAuthMethod.authMethodType) === null || _w === void 0 ? void 0 : _w.toString(),
                        _l),
                        _j.sigName = 'mfa-auth-sig-lit-action',
                        _j),
                        _h)])];
            case 3:
                mfaauthresponse = _4.sent();
                setMFAProgress && setMFAProgress(50);
                console.log('getMFASessionSig==  mfaauthresponse', mfaauthresponse, litSession);
                return [3 /*break*/, 7];
            case 4:
                e_2 = _4.sent();
                _d = (_c = console).log;
                _e = ['getMFASessionSig== ispermit',
                    e_2,
                    LIT_RPC_URL,
                    ENV_LIT_NETWORK,
                    litSession,
                    MFA_AUTH_ACTION];
                _m = {
                    tokenId: (_x = ethers.BigNumber.from(pkp.tokenId)) === null || _x === void 0 ? void 0 : _x.toHexString(),
                    publicKey: pkp.publicKey
                };
                _o = {};
                return [4 /*yield*/, getAuthId(currentAuthMethod, pkp, litSession)];
            case 5:
                _m.auth1 = (_o.authId = _4.sent(),
                    _o.authMethodType = (_y = currentAuthMethod.authMethodType) === null || _y === void 0 ? void 0 : _y.toString(),
                    _o);
                _p = {};
                return [4 /*yield*/, getAuthId(MFAAuthMethod, pkp, litSession)];
            case 6:
                _d.apply(_c, _e.concat([(_m.auth2 = (_p.authId = _4.sent(),
                        _p.authMethodType = (_z = MFAAuthMethod.authMethodType) === null || _z === void 0 ? void 0 : _z.toString(),
                        _p),
                        _m)]));
                return [3 /*break*/, 7];
            case 7:
                console.log('getMFASessionSig== ', pkp.publicKey);
                setMFAProgress && setMFAProgress(75);
                if (!(currentAuthMethod && MFAAuthMethod)) return [3 /*break*/, 11];
                _g = (_f = litNodeClient).getLitActionSessionSigs;
                _q = {
                    litActionCode: (_0 = Buffer.from(MFA_AUTH_ACTION)) === null || _0 === void 0 ? void 0 : _0.toString('base64'),
                    pkpPublicKey: pkp.publicKey,
                    expiration: new Date(Date.now() + sessionLength * 1000).toISOString(),
                    resourceAbilityRequests: [
                        {
                            resource: new LitPKPResource('*'),
                            ability: LitAbility.PKPSigning,
                        },
                        {
                            resource: new LitActionResource('*'),
                            ability: LitAbility.LitActionExecution,
                        },
                    ]
                };
                _r = {
                    tokenId: (_1 = ethers.BigNumber.from(pkp.tokenId)) === null || _1 === void 0 ? void 0 : _1.toHexString(),
                    publicKey: pkp.publicKey
                };
                _s = {};
                return [4 /*yield*/, getAuthId(currentAuthMethod, pkp, litSession)];
            case 8:
                _r.auth1 = (_s.authId = _4.sent(),
                    _s.authMethodType = (_2 = currentAuthMethod.authMethodType) === null || _2 === void 0 ? void 0 : _2.toString(),
                    _s);
                _t = {};
                return [4 /*yield*/, getAuthId(MFAAuthMethod, pkp, litSession)];
            case 9: return [4 /*yield*/, _g.apply(_f, [(_q.jsParams = (_r.auth2 = (_t.authId = _4.sent(),
                        _t.authMethodType = (_3 = MFAAuthMethod.authMethodType) === null || _3 === void 0 ? void 0 : _3.toString(),
                        _t),
                        _r.sigName = 'mfa-auth-sig-session-sigs',
                        _r),
                        _q)])];
            case 10:
                litActionSessionSigs = _4.sent();
                console.log('MFASessionSigs=>', litActionSessionSigs);
                setMFAProgress && setMFAProgress(100);
                return [2 /*return*/, litActionSessionSigs];
            case 11: return [2 /*return*/, null];
        }
    });
}); };
